import API from '../../../../common/http/api.fetch';
// import I18N from '../../../../common/utils/util.i18n';
import {info, success, responseMessage} from '../../../../common/utils/util.notifier';
import { GRID_FETCH, GRID_RELOAD, GRID_FILTER, GRID_SELECT_ALL } from '../../../../common/grid/grid.constants';
import { TYPES as ACC_TYPES } from '../../accreditation-action-type.constants';
import { IDS } from '../settings-action-id.constants';
import { getDocFileNameFromPath } from "../../../../common/utils/util.path";
import truncate from 'lodash/truncate';
import {TAB_SELECT} from "../../../../common/tabs/tabs.constants";

// const localizeType = (code, defaultName) => {
//     const textId = `DOCUMENT_MANAGEMENT.TYPES.${code.toUpperCase()}`;
//     const translation = I18N.translate(textId);
//     return translation === textId ? defaultName : translation
// };

export const fetchSloRequiredDocsGrid = (filter) => {
    if(!filter.scheme_code)
        return dispatch => {};

    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-groups-grid',
            method: 'GET',
            params: {
                ...filter,
                scope_subject_types: 'slo',
                path: undefined
            }
        }).then(({data}) => {

            // parse json string to array of objects
            const items = data.items.map( item => ({
                ...item,
                requirements: JSON.parse(item.requirements)
            }));

            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                ...data,
                items: items.map( item => ({
                    ...item,
                    type: item.type_name,
                    filename: getDocFileNameFromPath(item.doc_uri),
                    requirements: item.requirements.map(doc => doc.name).join(),
                    requirementsColumn: truncate(item.requirements.map(doc => doc.name).join(),{ 'length': 50}),
                    sampleDocFilename: getDocFileNameFromPath(item.sample_doc_uri),
                }))
            })
        }, error => {
            responseMessage(error);
        });
    };
}

export const exportSloRequiredDocs = (filter, downloadFile) => {
    if(!filter.scheme_code)
        return dispatch => {};

    info('Please wait...', false);
    return dispatch => {
        return API.fetch({
            url:    '/rco/export-evidence-groups',
            method: 'GET',
            params: {
                ...filter,
                scope_subject_types: 'slo',
                limit: undefined,
                offset: undefined,
                path: undefined
            }
        }).then(({data}) => {
            downloadFile('/' + data.path)
            success('Export Complete!');
        }, error => {
            responseMessage(error);
        });
    };
}

export const addSloRequiredDoc = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/add-evidence-group',
            method: 'POST',
            data
        }).then(response => {
            success('COMMON.SERVER_RESPONSE.ITEM_ADDED');
            dispatch({
                type: GRID_RELOAD,
                id: IDS.accSettings,
                path: IDS.sloRequiredDocsGrid,
            });
            dispatch({
                type: TAB_SELECT,
                id: IDS.app_accreditation_scheme_settings_slo_required_docs,
                state: IDS.app_accreditation_scheme_settings_slo_required_docs_list,
            });
        }, error => {
            responseMessage(error);
        });
    };
}

export const editSloEvidenceGroup = (data) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/edit-slo-evidence-group',
            method: 'POST',
            data,
        }).then(response => {
            dispatch({
                type:   GRID_RELOAD,
                id:     IDS.accSettings,
                path:   IDS.sloRequiredDocsGrid,
            })
            success('COMMON.SERVER_RESPONSE.ITEM_UPDATED');
        }, error => {
            responseMessage(error);
        });
    };
}

export const fetchEnabledHeadOffices = (schemeId) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/regulatory-framework-locations',
            method: 'GET',
            params: {
                asc_id: schemeId
            }
        }).then(({data}) => {
            dispatch({
                type: ACC_TYPES.FETCH_SCHEME_ENABLED_HEAD_OFFICES,
                id: IDS.sloRequiredDocs,
                schemeId,
                items: data.items.map( item => ({
                    value: item.slo_uuid,
                    label: item.slo_name,
                }))
            });
            return data.items;
        })
    }
}

export const fetchEnabledSiteLocations = (schemeId, headOfficeUuid) => {
    return dispatch => {
        return API.fetch({
            url: '/rco/regulatory-framework-locations',
            method: 'GET',
            params: {
                asc_id: schemeId,
                hof_uuid: headOfficeUuid,
            }
        }).then(({data}) => {
            dispatch({
                type: ACC_TYPES.FETCH_SCHEME_ENABLED_SITE_LOCATIONS,
                id: IDS.sloRequiredDocs,
                headOfficeUuid,
                items: data.items.map(item => ({
                    value: item.slo_uuid,
                    label: item.slo_name,
                }))
            });
            return data.items;
        })
    }
}

export const fetchSloRequiredDocsImportsGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-groups-imports-grid',
            method: 'GET',
            params: {
                ...filter,
                path: undefined,
            }
        }).then(({data}) => {
            dispatch({
                type:   GRID_FETCH,
                id:     IDS.accSettings,
                path:   filter.path,
                ...data,
                items: data.items,
            })
        }, error => {
            responseMessage(error);
        })
    }
}